<!--
  @Author: ljl
  @Desc: 首页
  @Date: 2024-03-12
-->

<template>
  <div class="index-page-bg-fff">
    <div class="tab-notice-line">
      <!-- 第一块 -->
      <div class="left-one-part">
        <div class="left-title">
          <span>您好，管理员，欢迎使用本系统～</span>
          <div
            class="left-tip"
            v-if="!!rateRangeList && rateRangeList.length > 0"
            @click="dialogRateRangeVisible = true"
          >
            <span>当前执行费率：</span>
            <span
              style="color:#1985FF;"
              v-if="rateRangeList.filter(it => !!it.isCurrent)[0]"
              >费率{{
                rateRangeList.filter(it => !!it.isCurrent)[0].distributeRate
              }}</span
            >
            <img
              src="../../../static/icons/tishi.png"
              width="18"
              height="18"
              alt="warn"
            />
          </div>
        </div>
        <div class="money_title">
          <div
            class="money_each"
            v-for="(item, index) in dataBoardMoneyParams"
            :key="index"
            @click="jumpClick(item)"
          >
            <img
              :class="[index == 1 ? 'bgOne_no' : 'bgOne']"
              :src="item.bgOneUrl"
              :style="item.bgOneStyle"
              alt=""
            />
            <img
              :class="[index == 1 ? 'bgTow_no_bg' : 'bgTow']"
              v-if="!!item.bgTowUrl"
              :src="item.bgTowUrl"
              :style="item.bgTowStyle"
              alt=""
            />
            <span class="bgTow_no" v-else :style="item.bgTowStyle"></span>
            <div class="text">
              <span>{{ item.name }}</span>
              <span>{{ item.amount }}</span>
              <div class="btn">查看详情</div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-one-part">
        <div class="right-title">
          <span>快捷操作</span>
        </div>
        <div class="right-item">
          <div
            class="data-item"
            style="background: #F8F9FD;"
            @click="jumpToPage('', 'position')"
          >
            <img
              class="big-icon"
              src="../../../static/home/pic_home_renwu.png"
            />
            <div class="big-text">
              发布任务
            </div>
          </div>
          <div
            class="data-item"
            style="background: #FFF7F8;"
            @click="jumpToPage('', 'employ')"
          >
            <img
              class="big-icon"
              src="../../../static/home/pic_home_zijin.png"
            />
            <div class="big-text">
              用工结算
            </div>
          </div>
          <div
            class="data-item"
            style="background: #FFFBF5;"
            @click="jumpToPage('', 'applyInvoice')"
          >
            <img
              class="big-icon"
              src="../../../static/home/pic_home_fapiao.png"
            />
            <div class="big-text">
              申请开票
            </div>
          </div>
          <div
            class="data-item"
            @click="jumpToPage('', 'selCooChildAccount')"
            v-if="showSelCooChildAccount"
          >
            <img
              class="big-icon"
              src="../../../static/home/pic_home_zhanghao.png"
            />
            <div class="big-text">
              账号管理
            </div>
          </div>

          <div
            class="data-item"
            @click="jumpToPage('', 'electronicReceipt')"
            v-if="showElectronicReceipt"
          >
            <img
              class="big-icon"
              src="../../../static/home/pic_home_dianzi.png"
            />
            <div class="big-text">
              电子回单
            </div>
          </div>

          <div class="data-item" @click="jumpToPage('/taxProveList', 'tax')">
            <img
              class="big-icon"
              src="../../../static/home/pic_home_wanshui.png"
            />
            <div class="big-text">
              完税证明
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="margin-bg"></div>
    <!--余额 & 消息通知-->
    <div class="tab-notice-line">
      <div class="left-two-part">
        <div class="title">
          <span class="tab-text notice-text">充值账户信息</span>
        </div>
        <div class="recharge-acc-info">
          <div class="recharge-acc-info-item">
            <div>
              <span class="lable-info">充值账户：</span
              ><span class="value-info">
                <span>{{ resRechargeInfo.receiverAccountName }}</span>
              </span>
            </div>

            <div>
              <span class="lable-info">充值账号：</span
              ><span class="value-info"
                >{{ resRechargeInfo.receiverAccountNo }}
              </span>
            </div>

            <div>
              <span class="lable-info">打款备注：</span
              ><span class="value-info"
                ><i class="value-info-color"
                  >请填写"服务费"、"转账"、"汇款"、"转账"、"无附言"、"无备注"或不填，其他备注将退款</i
                ></span
              >
            </div>
          </div>

          <div class="recharge-acc-info-item">
            <div>
              <span class="lable-info">开户行：</span>
              <el-popover
                placement="top-start"
                trigger="hover"
                :content="resRechargeInfo.receiverBankBranchName"
                class="info-value"
                style="width: 80%"
              >
                <span slot="reference">{{
                  resRechargeInfo.receiverBankBranchName
                }}</span>
              </el-popover>
            </div>
            <div>
              <span class="lable-info">行&nbsp;&nbsp;&nbsp;别：</span
              ><span class="value-info">{{ resRechargeInfo.bankType }}</span>
            </div>
            <div>
              <span class="lable-info">联行号：</span
              ><span class="value-info"
                >{{ resRechargeInfo.receiverBankBranchNo }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- 消息通知 -->
      <div class="right-two-part">
        <notice-list></notice-list>
      </div>
    </div>

    <!-- 阶梯费率展示 -->
    <el-dialog
      title="当前执行费率"
      :visible.sync="dialogRateRangeVisible"
      :width="'800px'"
      :top="'0'"
      id="contract_modal"
    >
      <div
        class="rate_range"
        v-if="!!rateRangeList && rateRangeList.length > 0"
      >
        <RateRange :data="rateRangeList" :issueData="mockObject"></RateRange>
      </div>
    </el-dialog>

    <!-- 签署合同 -->
    <el-dialog
      title="签署合同"
      :visible.sync="dialogVisible"
      :width="'1040px'"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :top="'0'"
      id="contract_modal"
    >
      <component
        :userMessage="userMessage"
        :modalHeight="modalHeight"
        :resCooperatorData="resCooperatorData"
        :is="currentComponent"
        :resRateData="resRateData"
        :computeMode="computeMode"
        :contractType="contractType"
      ></component>

      <div slot="footer" class="dialog-footer">
        <span class="btnLineColor" v-if="!isNeed" @click.stop="xhrChangeManager"
          >更换经办人</span
        >
        <span class="btnLineColor" @click.stop="xhrDownloadFile">导出合同</span>
        <span class="btnFullColor" @click.stop="signContract">签署合同</span>
      </div>
    </el-dialog>

    <!-- 签署意愿认证 -->
    <el-dialog
      title="签署意愿认证"
      :lock-scroll="false"
      :visible.sync="dialogVisibleWish"
      @close="closeDialogVisibleWish('dialogVisibleWish')"
    >
      <el-form
        label-width="150px"
        :model="handledByParams"
        :rules="handledByRule"
        ref="handledByParamsRef"
      >
        <el-form-item label="经办人姓名:" prop="operatorName">
          <span>{{ handledByParams.operatorName }}</span>
        </el-form-item>

        <el-form-item label="手机号:" prop="operatorMobile">
          <span>{{ handledByParams.operatorMobile }}</span>
        </el-form-item>

        <el-form-item label="验证码:" prop="smsCode">
          <el-input
            :style="{ width: '152px' }"
            placeholder="请输入验证码"
            type="text"
            v-model="handledByParams.smsCode"
            clearable
          ></el-input>
          <a
            class="btnLargeLineColor"
            @click="xhrSendSingSms"
            :style="{ width: '96px' }"
          >
            <span>{{ countdownText }}</span>
          </a>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <span
          class="btnLineColor"
          @click.stop="closeDialogVisibleWish('dialogVisibleWish')"
          >取消</span
        >
        <span class="btnFullColor" @click.stop="xhrSign">确认签署</span>
      </div>
    </el-dialog>

    <!-- 签署成功 -->
    <el-dialog
      title="签署成功"
      :lock-scroll="false"
      :visible.sync="dialogVisibleSuccess"
      @close="closeDialogVisibleWish('dialogVisibleSuccess')"
    >
      <div class="signSuccStyle">
        <img src="../../../static/icons/pic_state_green@2x.png" />
        <div class="signSuccText">
          <div class="signSuccTitle">签署成功</div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <span class="btnFullColor" @click.stop="toPage('/contractDownload')"
          >下载合同</span
        >
      </div>
    </el-dialog>

    <!-- 下载变更通知函  -->
    <el-dialog
      title="提示"
      :lock-scroll="false"
      :visible.sync="dialogVisibleNoticeLetter"
      id="noticeLetter"
    >
      <p>
        您的充值帐户信息已于
        {{ resNoticeLetter.createTime }} 发生变更，请使用最新的帐户进行充值。
      </p>

      <div slot="footer" class="dialog-footer">
        <span class="btnFullColor" @click="xhrDownloadNotice">
          我已知晓，并下载变更函</span
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  checkNull,
  fenToYuan,
  getLocal,
  priceToThousands,
  fenToWanNoFixed,
  setLocal
} from "../../filters/filters";
import { HTTP_CODE } from "../../../build/axios_constants";
import { MessageBox } from "element-ui";
import noticeList from "../../components/notice-list";
import { exportContractTemplate } from "../../service/apis";
import downloadButtonVue from "../../components/downloadButton.vue";
import { downloadChangeNoticeLetter } from "../../service/apis";
import { MONEY_PARAMS_LIST } from "../../service/businessConsts";
import { handledByRule } from "./vdt/form_validata";
import Contract from "./component/contract.vue";
import Replenishment from "./component/replenishment.vue";
import PriceIncrease from "./component/priceIncrease.vue";
import RateRange from "../../components/rateRange.vue";

export default {
  name: "index-merchant",
  components: {
    "notice-list": noticeList,
    "download-button": downloadButtonVue,
    Contract,
    Replenishment,
    PriceIncrease,
    RateRange
  },

  data() {
    return {
      handledByRule: handledByRule,
      resDataList: [], // 签署合同 月交易额｜管理费率 table
      resServiceData: [], // 签署合同 服务类型｜服务类目 table
      dialogVisibleWish: false, // 签署意愿认证弹窗
      dialogVisibleSuccess: false, // 签署成功弹窗
      dialogVisible: false, // 签署合同弹窗
      dialogVisibleNoticeLetter: false, // 弹窗 - 下载变更通知函
      handledByList: [], // 经办人数组
      handledByParams: {
        operatorName: "",
        operatorMobile: "",
        smsCode: ""
      },
      timer: null,
      countdownText: "获取验证码",
      exportUrlPdf: exportContractTemplate, // 导出合同接口
      downloadUrl: downloadChangeNoticeLetter, // 下载通知函
      userMessage: {},
      resRechargeInfo: {}, //充值帐户信息
      resCooperatorData: {}, //查询商户合同数据
      resNoticeLetter: {}, // 变更通知函数据
      // 首页数据看板金额查询参数 数据类型: 1结算金额 2充值金额 3管理费金额 4可开票金额
      dataBoardMoneyParams: MONEY_PARAMS_LIST,
      modalHeight: "calc(783px - 64px - 65px)", // 弹窗高度
      // 记录填写经办人 还是 直接签署合同
      isNeed: false, // true  进入经办人实名认证页面或小额打款认证页面 | false 需要签署协议
      resContractInforMation: {}, // 根据返回值 判断 补充协议 还是 合同
      currentComponent: "PriceIncrease", // Replenishment 补充 Contract 双章 PriceIncrease 涨价
      contractType: 21, // 区分双章合同还是补充协议 21 双章 10 补充 13 涨价 15 费率新规
      resRateData: [
        // 费率表格数据
        {
          key: "rateOne",
          label: "200万以下（不包含200万）",
          value: ""
        },
        {
          key: "rateTwo",
          label: "200万-500万（包含200万）",
          value: ""
        },
        {
          key: "rateThree",
          label: "500万-1000万（包含500万）",
          value: ""
        },
        {
          key: "rateFour",
          label: "1000万-3000万（包含1000万）",
          value: ""
        },
        {
          key: "rateFive",
          label: "3000万以上（包含3000万）",
          value: ""
        }
      ],
      computeMode: 0, // 费率模式；3：阶梯费率；其他均为固定费率
      rateRangeList: [],
      mockObject: {},
      dialogRateRangeVisible: false,
      showElectronicReceipt: false,
      showSelCooChildAccount: false
    };
  },

  created() {
    this.xhrQueryPhaseRule();
    this.xhrIsNeedCompleteContractInformation();
    this.xhrChangeNoticeLetter(); // 弹窗 - 下载变更通知函
    // 首页数据看板金额查询
    for (let i = 0; i < this.dataBoardMoneyParams.length; i++) {
      if (!!this.dataBoardMoneyParams[i].dataType) {
        this.xhrDataBoardMoney(this.dataBoardMoneyParams[i]);
      }
    }
  },

  mounted() {
    this.xhrChildAccountCooperatorMenus();
    this.userMessage = JSON.parse(getLocal("userMessage"));
    this.xhrRechargeInfo();
    this.xhrAccountBalance();
    // 如果弹电子合同签约页面则清空历史栈
    if (localStorage.getItem("routerIndexMer")) {
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新
        window.addEventListener("popstate", this.backChange, false); //false阻止默认事件
      }
    }
    this.modifyHeight();
    // 监听屏幕高度修改合同模版高度
    window.addEventListener("resize", this.modifyHeight);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.modifyHeight);
  },

  methods: {
    // 判断快捷操作的跳转用的
    xhrChildAccountCooperatorMenus() {
      this.$http.postselChildAccountCooperatorMenus().then(res => {
        if (!checkNull(res.data)) {
          this.hasAccountManagement(JSON.parse(res.data));
        }
      });
    },

    // 递归检查函数，处理多级嵌套的children
    hasAccountManagement(items) {
      // 遍历当前层级的所有项
      return items.some(item => {
        // 检查当前项的name是否包含"账号管理"
        if (item.name.includes("账号管理")) {
          this.showSelCooChildAccount = true;
        }
        if (item.name.includes("电子回单")) {
          this.showElectronicReceipt = true;
        }
        // 如果有子项，递归检查子项
        if (item.children && item.children.length > 0) {
          return this.hasAccountManagement(item.children);
        }
        return false;
      });
    },

    // xhr -- 首页阶梯费率展示
    xhrQueryPhaseRule() {
      this.$http.queryPhaseRule({}).then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          if (!!res.data) {
            this.rateRangeList = !!res.data.cooperatorPhaseRules
              ? res.data.cooperatorPhaseRules.map(it => {
                  // 处理成无穷大
                  it.rateRange =
                    fenToWanNoFixed(it.lowerLimitAmount) +
                    "～" +
                    fenToWanNoFixed(it.upperLimitAmount);
                  return it;
                })
              : [];
            this.mockObject = {
              customerCurrentMonthDistributeAmount: fenToYuan(
                res.data.customerCurrentMonthDistributeAmount
              ),
              customerLastMonthDistributeAmount: fenToYuan(
                res.data.customerLastMonthDistributeAmount
              )
            };
          }
        }
      });
    },
    // xhr -- 首页数据看板金额查询
    xhrDataBoardMoney(data) {
      this.$http.getDataBoardMoney({ dataType: data.dataType }).then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          if (!res.data.amount || res.data.amount == 0) {
            data.amount = "0.00";
            return false;
          }
          data.amount = priceToThousands(fenToYuan(res.data.amount));
        }
      });
    },

    // xhr -- 下载通知函
    xhrDownloadNotice() {
      let url =
        this.downloadUrl +
        "?url=" +
        this.resNoticeLetter.noticeLetterUrl +
        "&isHide=true&token=" +
        getLocal("Authorization");

      window.open(url);

      this.dialogVisibleNoticeLetter = false;
    },

    // xhr -- 变更通知函
    xhrChangeNoticeLetter() {
      let param = {
        isHide: true
      };
      this.$http.getChangeNoticeLetter(param).then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          if (!checkNull(res.data) && !checkNull(res.data.noticeLetterUrl)) {
            this.dialogVisibleNoticeLetter = true;
            this.resNoticeLetter = res.data;
          } else {
            this.dialogVisibleNoticeLetter = false;
          }
        }
      });
    },

    // xhr -- 是否需呀补全合同信息
    xhrIsNeedCompleteContractInformation(isSubmit) {
      this.$http.getIsNeedCompleteContractInformation().then(async res => {
        if (res.statusCode === HTTP_CODE.suc) {
          // 保存商户费率类型 判断余额管理是否显示管理费退还按钮
          setLocal("computeMode", res.data.computeMode);
          this.resContractInforMation = res.data;
          this.computeMode = res.data.computeMode;
          if (!!isSubmit) {
            // 为双章或补充协议签署提交返回  补充协议为 false 说明签署流程结束
            if (
              !res.data.stepRateSupplementarySignNeed &&
              !res.data.markupsupplementarySignNeed
            ) {
              this.dialogVisible = false;
              this.dialogVisibleSuccess = true;
              return;
            } else {
              this.handledByParams.smsCode = ""; // 清空验证码
              this.$message({
                type: "success",
                message: `${
                  !!res.data.stepRateSupplementarySignNeed
                    ? "《自由职业者综合服务协议》签署成功！请继续签署补充协议"
                    : "商户补充协议-费率新规签署成功！请继续签署补充协议"
                }`
              });
            }
          }

          // 如果都为false 说明为线下签署 或 线上签署流程已经完毕
          if (
            !res.data.need &&
            !res.data.signNeed &&
            !res.data.stepRateSupplementarySignNeed &&
            !res.data.markupsupplementarySignNeed
          ) {
            this.dialogVisible = false;
            return;
          }

          /**
           * need 是否需要进入信息补全页面或支付验证页面
           * needSign  是否需要签署协议
           * stepRateSupplementarySignNeed  需要签署阶梯费率新规
           * 必须用 res.data.signNeed 做为判断条件 （双章合同与补充协议都需要签署的时候 先签署双章再签署补充）
           */
          this.dialogVisible = true;
          this.currentComponent = !!res.data.signNeed
            ? "Contract"
            : !!res.data.stepRateSupplementarySignNeed
            ? "Replenishment"
            : "PriceIncrease";
          this.isNeed = res.data.need;
          this.contractType = !!res.data.signNeed
            ? 21
            : !!res.data.stepRateSupplementarySignNeed
            ? 15
            : 13;
          await this.xhrWhitenessCooperatorData();
        }
      });
    },

    //xhr -- 当前账户余额   // 首页
    xhrAccountBalance() {
      var param = {
        subCompanyId: ""
      };
      this.$http.getCurrentAccountBalance(param).then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          this.dataBoardMoneyParams[0].amount = priceToThousands(
            fenToYuan(res.data.balance)
          );
        }
      });
    },

    //xhr -- 查询商户合同数据
    xhrWhitenessCooperatorData() {
      // 21 双章合同 10 补充协议 13 涨价协议 15 费率新规
      this.$http
        .postWhitenessCooperatorData({ contractType: this.contractType })
        .then(res => {
          if (res.statusCode === HTTP_CODE.suc) {
            // 直接带出经办人
            this.handledByParams.operatorMobile = res.data.operatorMobile;
            this.handledByParams.operatorName = res.data.operatorName;

            if (!!res.data.joinHygDistributeCompanyNameList) {
              res.data.joinHygDistributeCompanyNameList = res.data.joinHygDistributeCompanyNameList.map(
                (it, index) => {
                  return {
                    companyName: it,
                    index: index + 1
                  };
                }
              );
            }

            // distributeCompanySelfOperated: true, 自营, false, 加盟
            this.resCooperatorData = {
              ...res.data,
              distributeCompanySelfOperated: this.resContractInforMation
                .distributeCompanySelfOperated
            };

            if (!!this.resCooperatorData.serviceTypeList) {
              this.resCooperatorData.serviceTypeList.map((it, index) => {
                it.index = index + 1;
                return it;
              });
            }

            // 赋值阶梯费率列表
            this.resRateData.forEach(item => {
              for (let key in this.resCooperatorData) {
                if (key === item.key) {
                  item.value = this.resCooperatorData[key];
                }
              }
            });
          }
        });
    },

    // xhr - 更换经办人
    xhrChangeManager() {
      this.$confirm("确定要更换经办人吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http.getChangeManager().then(res => {
          if (res.statusCode === HTTP_CODE.suc) {
            this.$router.push({ name: "fill-in-information" });
          }
        });
      });
    },

    // xhr -- 导出文件
    xhrDownloadFile() {
      let url = `${
        this.exportUrlPdf
      }?key=hvyogo-beta/business_license/2023/02/20230216152150-1075799171744669696.pdf&open=1&token=${getLocal(
        "Authorization"
      )}`;
      window.open(url);
    },

    //xhr -- 充值账户信息详情
    xhrRechargeInfo() {
      var param = {
        subCompanyId: ""
      };
      this.$http.getRechargeInfo(param).then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          this.resRechargeInfo = res.data;

          if (res.data.receiverAccountName === "海南慧用工服务有限公司") {
            // 账户 === 海南慧用工服务有限公司
            // 收款账号 展示 ‘此账号暂停使用’
            this.resRechargeInfo.receiverAccountNo = "此账号暂停使用";
          } else if (res.data.receiverAccountNo == "--") {
            // 账号 === ‘--’
            //  收款账号 展示 '子账户暂未开通，请联系业务人员'
            this.resRechargeInfo.receiverAccountNo =
              "子账户暂未开通，请联系业务人员";
          } else {
            //  收款账号 展示 receiverAccountNo
            this.resRechargeInfo.receiverAccountNo = res.data.receiverAccountNo;
          }
        }
      });
    },

    // 确认签署
    xhrSign() {
      this.$refs.handledByParamsRef.validate(valid => {
        let params = {
          operatorMobile: this.handledByParams.operatorMobile,
          smsCode: this.handledByParams.smsCode,
          contractType: this.contractType
        };
        this.$http.postCooperatorSignContract(params).then(res => {
          if (res.statusCode === HTTP_CODE.suc) {
            this.dialogVisibleWish = false;
            this.xhrIsNeedCompleteContractInformation(true);
          }
        });
      });
    },

    // 获取验证码
    xhrSendSingSms() {
      let validateFieldList = [];
      this.$refs.handledByParamsRef.validateField(
        ["operatorName", "operatorMobile"],
        async valid => {
          if (!valid) {
            validateFieldList.push(valid);
            if (validateFieldList.length == 2) {
              if (typeof this.countdownText != "string") {
                return false;
              }

              this.$http
                .postContractSendSms({
                  operatorMobile: this.handledByParams.operatorMobile
                })
                .then(res => {
                  if (res.statusCode === HTTP_CODE.suc) {
                    this.$message({
                      type: "success",
                      message: "验证码发送成功"
                    });
                    this.countdown(); //验证码倒计时执行
                  } else {
                    this.countdownText = "获取验证码";
                  }
                });
            }
          }
        }
      );
    },

    // 签署合同
    signContract() {
      if (!!this.isNeed) {
        this.$router.push({ name: "fill-in-information" });
      } else {
        this.dialogVisibleWish = true;
      }
    },

    // 根据屏幕尺寸修改弹窗高度
    modifyHeight() {
      const clientHight = document.body.clientHeight;
      if (clientHight < 710) {
        this.modalHeight = "calc(690px - 64px - 65px)";
      }
      if (clientHight > 710) {
        this.modalHeight = "calc(783px - 64px - 65px)";
      }
    },

    // 关闭弹窗
    closeDialogVisibleWish(dialog) {
      if (!!this.$refs.handledByParamsRef) {
        this.$refs.handledByParamsRef.clearValidate();
      }
      this[dialog] = false;
      clearInterval(this.timer);
      this.countdownText = "获取验证码";
    },

    // 验证码
    countdown() {
      this.countdownText = 60;
      this.timer = setInterval(() => {
        this.countdownText--;
        if (this.countdownText === 0) {
          clearInterval(this.timer);
          this.countdownText = "重新发送";
        }
      }, 1000);
    },

    // 首页数据看板跳转
    jumpClick(item) {
      let routerPath;
      if (item.dataType == 4 && this.userMessage.distributeCompanyType == 1) {
        routerPath = "/invoiceApply";
      } else {
        routerPath = item.jumpUrl;
      }
      this.$router.push({
        path: routerPath
      });
    },

    // 跳转页面
    jumpToPage(path, origin) {
      if (origin === "tax") {
        this.$router.push({ path: path });
      } else if (origin === "position") {
        // 1任务管理入口
        if (this.userMessage.distributeCompanyType == 1) {
          // distributeCompanyType：1, 江西慧用工
          this.$router.push({ path: "/taskCenList" }); // 任务中心 - 任务列表页面
        } else {
          this.$router.push({ path: "/taskList" }); // 用工中心 - 任务列表页面
        }
      } else if (origin === "applyInvoice") {
        // 3申请开票入口
        if (this.userMessage.distributeCompanyType == 1) {
          // distributeCompanyType：1, 江西慧用工
          this.$router.push({ path: "/invoiceApply" }); // 发票申请页面
        } else {
          this.$router.push({ path: "/billingRecordList" }); // 开票记录页面
        }
      } else if (origin === "employ") {
        // 2用工结算入口
        // this.$router.push({ name: this.userMessage.batchPath });
        this.$router.push({ path: "/employmentStatement" }); // 用工结算入口
      } else if (origin == "electronicReceipt") {
        this.$router.push({ path: "/electronicReceipt" }); // 电子回单页面
      } else if (origin == "selCooChildAccount") {
        this.$router.push({ path: "/selCooChildAccount" }); // 账号管理
      }
    },

    // 页面跳转
    toPage(url) {
      this.$router.push({
        path: url
      });
    }
  },
  destroyed() {
    // 如果弹电子合同签约页面则清空历史栈
    if (localStorage.getItem("routerIndexMer")) {
      window.removeEventListener("popstate", this.backChange, false);
    }
  }
};
</script>

<style>
/* 变更函 */
#noticeLetter .dialog-footer > button {
  padding: 0 10px;
}
#noticeLetter p {
  margin: 0 10px 25px 10px;
}

/* 合同签署样式 */
#contract_modal {
  padding: 0;
}
#contract_modal .el-dialog {
  margin: 40px auto 0;
}
#contract_modal .el-dialog__body {
  padding: 0;
}

.right-two-part .right-notice-part .notice-list {
  max-height: 190px !important;
  /* overflow-y: auto !important; */
}
</style>

<style lang="scss" scoped>
.tab-notice-line {
  display: flex;
  justify-content: space-between;

  .left-one-part {
    width: 70%;
    height: 293px;
    background: #ffffff;
    border-radius: 2px;

    .left-title {
      width: 100%;
      height: 56px;
      line-height: 56px;
      background: #ffffff;
      box-shadow: 0px 1px 0px 0px #eeeeee;
      border-radius: 2px 2px 0px 0px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #272727;
      display: flex;
      justify-content: space-between;
      padding: 0 25px;
      .left-tip {
        display: flex;
        align-items: center;
        img {
          margin-left: 2px;
        }
      }
    }

    .money_title {
      height: 156px;
      width: 100%;
      width: calc(100% - 42px);
      display: flex;
      justify-content: space-between;
      margin: 21px auto;

      .money_each {
        position: relative;
        cursor: pointer;
        width: 23.5%;
        background-color: #fff;
        height: 156px;
        background: linear-gradient(173deg, #ebedee 0%, #ffffff 100%);
        box-shadow: 0px 4px 15px 0px rgba(92, 133, 168, 0.1);
        border-radius: 2px;
        border: 1px solid #ffffff;
        &:nth-child(1) {
          border: none;
          background: url("../../../static/home/bg_home_balance.png") no-repeat;
          background-size: 100% calc(100% * (168 / 156));
          background-position: center;
          &:hover {
            background-color: #57b2ff;
            background: url("../../../static/home/bg_home_balance.png")
              no-repeat;
            background-size: 100% calc(100% * (168 / 156));
            background-position: center;
          }
          .text {
            span {
              color: #fff !important;
            }
          }
          .btn {
            display: block;
            width: 67px;
            height: 20px;
            background: #ffffff;
            border-radius: 2px;
            font-size: 12px;
            font-family: PingFangTC-Regular, PingFangTC;
            color: #1985ff;
            text-align: center;
            line-height: 20px;
          }
        }
        &:hover {
          background: linear-gradient(180deg, #e6eaed 0%, #fafafa 100%);
          box-shadow: 0px 4px 15px 0px rgba(92, 133, 168, 0.1);
          .bgOne {
            animation: bgOneHover 0.2s steps(16) forwards;
          }
          .bgTow {
            animation: bgTowHover 0.2s steps(16) forwards;
          }

          .bgTow_no_bg {
            animation: bgTow_no_Hover 0.2s steps(16) forwards;
          }

          .bgOne_no {
            animation: bgOne_no_Hover 0.2s steps(16) forwards;
          }

          .bgTow_no {
            animation: bgTowHover 0.2s steps(16) forwards;
          }
        }

        .bgOne_no {
          position: absolute;
          z-index: 99;
          backdrop-filter: blur(2px); // 背景图模糊
          animation: bgOne_no_None 0.2s steps(16) forwards;
          display: block;
        }
        .bgTow_no_bg {
          position: absolute;
          z-index: 98;
          animation: bgTow_no_None 0.2s steps(16) forwards;
          display: block;
        }

        .bgOne {
          position: absolute;
          z-index: 99;
          backdrop-filter: blur(2px); // 背景图模糊
          animation: bgOneNone 0.2s steps(16) forwards;
          display: block;
        }
        .bgTow {
          position: absolute;
          z-index: 98;
          animation: bgTowNone 0.2s steps(16) forwards;
          display: block;
        }
        .bgTow_no {
          position: absolute;
          background-color: #1985ff;
          border-radius: 4px;
          z-index: 98;
          animation: bgTowNone 0.2s steps(16) forwards;
          display: block;
        }

        .text {
          position: absolute;
          top: 58px;
          display: flex;
          width: 100%;
          height: auto;
          flex-direction: column;
          padding-left: 18px;
          span {
            display: block;
            &:nth-child(1) {
              font-size: 12px;
              margin-top: 4px;
              font-family: PingFangSC-Regular, PingFang SC;
              color: #8c8c8c;
              margin-bottom: 5px;
            }
            &:nth-child(2) {
              font-size: 18px;
              font-family: AlibabaSans102Ver2-Medium, AlibabaSans102Ver2;
              color: #272727;
              margin-bottom: 10px;
            }
          }
          .btn {
            font-size: 12px;
            font-family: PingFangTC-Regular, PingFangTC;
            color: #1985ff;
          }
        }
      }
    }
  }

  .right-one-part {
    width: 28%;
    height: 293px;
    background: #ffffff;
    border-radius: 2px;

    .right-title {
      width: 100%;
      height: 56px;
      line-height: 56px;
      background: #ffffff;
      box-shadow: 0px 1px 0px 0px #eeeeee;
      border-radius: 2px 2px 0px 0px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #272727;
      display: flex;
      justify-content: space-between;
      padding: 0 25px;
    }

    .right-item {
      padding: 22px;
      display: grid;
      grid-template-columns: repeat(3, 1fr); /* 一行 3 列，每列平均分配空间 */
      gap: 18px; /* 间距 */
      .data-item {
        width: 80px;
        height: 80px;
        background: #f5fbff;
        border-radius: 20px;
        padding: 0 10px;
        position: relative;

        .big-icon {
          width: 60px;
          height: 60px;
          // background-color: red;
          margin: 0 auto;
        }

        .big-text {
          position: absolute;
          bottom: 6px;
          left: 12px;
          width: 56px;
          height: 20px;
          line-height: 20px;
          font-weight: 500;
          font-size: 14px;
          color: #272727;
        }
      }
    }
  }

  .title {
    height: 56px;
    line-height: 56px;
    border-bottom: 1px solid #e5e5e5;
    box-sizing: border-box;

    .tab-text {
      color: #8c8c8c;
      text-align: center;
      font-size: 16px;
      display: inline-block;
      margin-left: 40px;
      cursor: pointer;
    }
    .notice-text {
      color: #272727;
      margin-left: 32px;
      cursor: auto;
      text-align: left;
    }
    .active {
      color: #272727;
      border-bottom: 4px solid #1a85ff;
    }
    .notice-more {
      margin-right: 32px;
      font-size: 14px;
      color: #1985ff;
      float: right;
      cursor: pointer;
    }
  }

  .left-two-part {
    width: 70%;
    height: 310px;
    background-color: #ffffff;
    border-radius: 2px;

    .title {
      width: 100%;
    }
    .able-balance {
      font-size: 30px;
      color: #ff943e;
      padding: 29px 0 29px 32px;
    }
    .margin-bg {
      height: 16px;
    }

    .recharge-acc-info {
      padding-top: 24px;
      display: flex;
      .recharge-acc-info-item {
        width: 50%;
        padding-left: 32px;
        display: flex;
        flex-direction: column;

        div {
          display: flex;
          justify-content: flex-start;
        }
        span {
          // display: inline-block;
          margin-bottom: 16px;
          color: #595959;
        }

        .value-info {
          width: 242px;
        }

        .value-info-color {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #d40000;
          line-height: 22px;
          text-align: left;
          font-style: normal;
        }

        .lable-info {
          display: block;
          width: 70px;
          height: 22px;
          color: #272727;
        }
      }
    }

    .content {
      padding: 24px 32px 0;
      display: flex;
      justify-content: space-between;
      .item {
        border: 1px solid #eeeeee;
        border-radius: 10px;
        width: 48%;
        height: 180px;
        padding: 32px 24px 0;
        font-size: 14px;
        cursor: pointer;
        .item-top {
          padding-bottom: 32px;
          display: flex;
          justify-content: space-between;
          div {
            width: 62.5%;
          }
          span {
            display: inline-block;
            width: 100%;
          }
          span:nth-child(1) {
            height: 20px;
            line-height: 20px;
            color: #595959;
            margin-bottom: 18px;
            width: 56px;
            border-bottom: 10px solid #e6f1ff;
          }
          span:nth-child(2) {
            height: 30px;
            line-height: 30px;
            font-size: 24px;
            color: #323232;
          }
        }

        .item-bottom {
          height: 47px;
          line-height: 47px;
          border-top: 1px solid #eeeeee;
          display: flex;
          justify-content: space-between;
          span {
            color: #595959;
          }
        }
      }
    }
  }

  .right-two-part {
    width: 28%;
    height: 310px;
    background: #ffffff;
    border-radius: 2px;
    .right-notice-part {
      width: 100%;
    }
  }
}

.entrance-title {
  margin-top: 24px;
  margin-bottom: 16px;
  font-size: 16px;
  color: #272727;
}

.data-line {
  margin-bottom: 36px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-radius: 4px 4px 2px 2px;

  .data-item {
    width: 23.5%;
    height: 230px;
    background-color: #ffffff;
    padding: 0 32px 32px;
    position: relative;
    text-align: center;
    .top-bar-img {
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
    }
    .big-icon {
      display: block;
      margin: 41px auto 33px;
    }
    .num-title {
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      color: #595959;
    }
    .num {
      height: 40px;
      line-height: 40px;
      font-size: 32px;
      color: #272727;
      margin: 16px auto 48px;
    }
    .bottom-btn {
      width: 100%;
      height: 44px;
      line-height: 44px;
      border: 1px solid #1985ff;
      font-size: 16px;
    }
  }
  .orange-item {
    position: relative;
    .num-dianzi {
      font-size: 12px;
      color: #8c8c8c;
      position: absolute;
      left: 0;
      bottom: 100px;
      width: 100%;
    }
    .bottom-btn {
      color: #ff8b38;
      border: 1px solid #ff8b38;
    }
  }
  .purple-item {
    .bottom-btn {
      color: #6255f2;
      border: 1px solid #6255f2;
    }
  }

  .green-item {
    .bottom-btn {
      color: #26bfa6;
      border: 1px solid #26bfa6;
    }
  }
}

@keyframes bgOne_no_Hover {
  0% {
    transform: translate(0px, 0px);
  }
  100% {
    transform: translate(-4px, 3px);
  }
}

@keyframes bgTow_no_Hover {
  0% {
    transform: translate(0px, 0px);
  }
  100% {
    transform: translate(4px, -3px);
  }
}

@keyframes bgOne_no_None {
  0% {
    transform: translate(-4px, 3px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}

@keyframes bgTow_no_None {
  0% {
    transform: translate(4px, -3px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}

@keyframes bgOneHover {
  0% {
    transform: translate(0px, 0px);
  }
  100% {
    transform: translate(4px, 3px);
  }
}
@keyframes bgOneNone {
  0% {
    transform: translate(4px, 3px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}

@keyframes bgTowHover {
  0% {
    transform: translate(0px, 0px);
  }
  100% {
    transform: translate(-4px, -3px);
  }
}

@keyframes bgTowNone {
  0% {
    transform: translate(-4px, -3px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}

.info-value {
  color: #595959;
  vertical-align: top;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.signSuccStyle {
  width: 444px;
  height: 200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 128px;
    height: 128px;
  }

  .signSuccText {
    width: 128px;
    height: 128px;
    font-weight: 400;
    color: #333333;
    text-align: center;
    .signSuccTitle {
      font-size: 20px;
      line-height: 41px;
    }
    .signSuccContent {
      height: 70px;
      font-size: 14px;
      line-height: 20px;
    }
  }
}
.rate_range {
  margin: 16px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/indexStatistic/indexMerchant.vue